export function copyTrainingRoutine(id) {
  return {
    type: '@training-routine/COPY_TRAINING_ROUTINE',
    payload: { id },
  };
}
